<script>
  import RichTextContent from '@/components/RichTextContent';
  import ProductTypeBlock from '@/components/FlexibleContent/ProductTypeBlock';

  export default {
    name: 'ArticleContent',
    components: {
      RichTextContent,
      ProductTypeBlock
    },
    props: {
      content: {
        type: Object,
        default: () => ({}),
        required: true
      }
    },
    data () {
      return {
        componentsMap: [
          {
            name: 'richText',
            component: RichTextContent
          },
          {
            name: 'productType',
            component: ProductTypeBlock
          }
        ]
      }
    },
    methods: {
      componentLoader (component) {
        const componentName = component.sys.contentType.sys.id
        const matched = this.componentsMap.find(entry => entry.name === componentName)
        return matched ? matched.component : false
      }
    }
  }
</script>

<template>
  <div
    v-if="content"
    class="space-y-12"
  >
    <component
      :is="componentLoader(component)"
      v-for="(component, i) in content"
      :key="i"
      :data="component"
    />
  </div>
</template>

<style scoped>

</style>
